



























import { Component, Vue, Prop } from "vue-property-decorator";
import VChatMessage from "./VChatMessage.vue";
import MessageEditor from "./MessageEditor.vue";
import {
  Message,
  saveMessage,
  getNewerMessages,
  getOlderMessages,
  readMessage
} from "@/api/message-api";
import parseISO from "date-fns/parseISO";
import ScrollMagicScene from "@/components/ScrollMagicScene.vue";

import MessageList from "@/components/MessageList.vue";

@Component({
  components: {
    VChatMessage,
    MessageEditor,
    ScrollMagicScene,
    MessageList
  }
})
export default class ProjectChatPage extends Vue {
  @Prop({ required: true }) projectId: any;

  messages: Message[] = [];
  timerId: any = null;

  lastReadMessageId: any = -1;

  get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  canWriteMessage() {
    return (
      this.permissions.includes("service/project_operation") ||
      this.permissions.includes("project/chat_operation")
    );
  }

  /**
   * 読み込んだメッセージの中で最新のID
   */
  get newestMessageId() {
    return this.messages.length ? this.messages.slice(-1)[0].messageId : "0";
  }

  /**
   * 読み込んだメッセージの中で最古のID
   */
  get oldestMessageId() {
    return this.messages.length ? this.messages[0].messageId : "0";
  }

  mounted() {
    // ポーリングを有効化する
    this.timerId = setInterval(() => this.loadNewerMessages(), 30 * 1000);
  }

  beforeDestroy() {
    // ポーリングを無効化する
    clearInterval(this.timerId);
  }

  async readMessage() {
    await readMessage(this.projectId, this.newestMessageId);
  }

  /**
   * 新しいメッセージを取得する
   */
  async getNewerMessages() {
    return await getNewerMessages(this.projectId, this.newestMessageId);
  }

  /**
   * 古いメッセージを取得する
   */
  async getOlderMessages() {
    return await getOlderMessages(this.projectId, this.oldestMessageId);
  }

  // 既読状態を更新する
  updateLastRead(lastReadMessageCreated: string | undefined) {
    if (this.messages.length && lastReadMessageCreated) {
      const lastRead = parseISO(lastReadMessageCreated);
      const lastReadMessage = this.messages
        .filter(m => m.created <= lastRead)
        .slice(-1)[0];
      if (lastReadMessage) {
        this.lastReadMessageId = lastReadMessage.messageId;
      } else {
        this.lastReadMessageId = -1;
      }
    } else {
      this.lastReadMessageId = -1;
    }
  }

  /**
   * 無限ロードの読み込み
   */
  async loadOlderMessages($state: any) {
    const { lastReadMessageCreated, messages } = await this.getOlderMessages();
    if (messages.length) {
      this.messages.unshift(...messages);
      $state.loaded();
    } else {
      $state.complete();
    }
    this.updateLastRead(lastReadMessageCreated);
  }

  /**
   * 新しいメッセージを読み込む
   */
  async loadNewerMessages() {
    const { lastReadMessageCreated, messages } = await this.getNewerMessages();
    if (messages.length) {
      this.messages.push(...messages);
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    }
    this.updateLastRead(lastReadMessageCreated);
  }

  /**
   * メッセージを送る
   */
  async sendMessage(data: FormData) {
    data.append("projectId", this.projectId);
    await saveMessage(data);
    await this.loadNewerMessages();
    await this.readMessage();
    // 最新のメッセージを既読にするので、読み込み直している
    // TODO: readの位置を直接書き換えて読み込み省く？
    await this.loadNewerMessages();
  }

  /**
   * 下までスクロールする
   */
  scrollToBottom() {
    const el = this.$refs.box as Element;
    el.scrollTop = el.scrollHeight;
  }

  messageToMe(message: Message): boolean {
    return message.to.some(
      m => m && m.user && m.user.userId === this.$store.state.user.userId
    );
  }
}
